import { Link, type ErrorComponentProps } from '@tanstack/react-router';
import { RiCompass3Line, RiErrorWarningLine, RiHome2Line, RiRefreshLine } from '@remixicon/react';
import { useTranslation } from 'react-i18next';
import { Button, buttonStyles } from './button';
import { EmptyState } from './empty-state';

function Centered({ children }: { children: React.ReactNode }) {
  return <div className="flex h-full min-h-dvh items-center justify-center bg-app p-24">{children}</div>;
}

export function RouteError({ error, reset }: ErrorComponentProps) {
  const { t } = useTranslation();
  return (
    <Centered>
      <EmptyState
        size="lg"
        icon={RiErrorWarningLine}
        title={t('errors.generic')}
        description={error instanceof Error ? error.message : undefined}
      >
        <Button variant="primary" leftIcon={RiRefreshLine} onClick={reset}>
          {t('common.retry')}
        </Button>
      </EmptyState>
    </Centered>
  );
}

export function RouteNotFound() {
  const { t } = useTranslation();
  return (
    <Centered>
      <EmptyState size="lg" icon={RiCompass3Line} title={t('errors.notFound')} description={t('errors.notFoundHint')}>
        <Link to="/" className={buttonStyles({ variant: 'primary' }).base()}>
          <RiHome2Line aria-hidden className={buttonStyles({ variant: 'primary' }).icon()} />
          <span className={buttonStyles().label()}>{t('common.home')}</span>
        </Link>
      </EmptyState>
    </Centered>
  );
}
